'use client';

import Image from 'next/image';
import React from 'react';

import { Button, Illustration, ModalContent, TagInfo } from '@/shared/ui';
import { AdditionalInfo } from '@/shared/ui/desktop/additional-info';
import { useStore } from '@/store/context';
import { GuideSteps } from '@/store/items-withdrawal/items-withdrawal';

import Guide1 from '../../../../public/assets/guide/guide-1.webp';
import Guide2 from '../../../../public/assets/guide/guide-2.webp';
import Guide3 from '../../../../public/assets/guide/guide-3.webp';
import Guide4 from '../../../../public/assets/guide/guide-4.webp';
import Guide5 from '../../../../public/assets/guide/guide-5.webp';
import styles from './styles.module.scss';

const infoByStep = {
  1: {
    image: Guide1,
    text: 'He will be at their home and always stand in one place',
  },
  2: {
    image: Guide2,
    text: 'Click “Join” and go to the seller on the server',
  },
  3: {
    image: Guide3,
    text: 'In the game, click “Friends” and teleport to the selle',
  },
  4: {
    image: Guide4,
    text: 'Do not add food or any other items to the trade with the seller during withdrawal transactions!',
  },
  5: {
    image: Guide5,
    text: 'If the seller does not accept trade requests, try again in 30 seconds',
  },
};

export const WithdrawalGuideContent = ({
  step,
  onClose,
}: {
  step: GuideSteps;
  onClose: () => void;
}) => {
  const withdrawalStore = useStore().withdrawal;
  if (!step) return null;

  return (
    <ModalContent className={styles['container']}>
      <ModalContent.Header>
        <div className={styles['header-text']}>
          <ModalContent.HeaderLabel
            className={styles['label--icon']}
            icon={'question-square'}
            variant={'primary'}
          >
            How to find a seller?
          </ModalContent.HeaderLabel>
        </div>
        <ModalContent.CloseButton onClick={onClose} />
      </ModalContent.Header>

      <ModalContent.Body className={styles['content']}>
        <div className={styles['image']}>
          <Image
            loading={'eager'}
            src={infoByStep[step].image}
            priority
            fetchPriority={'high'}
            placeholder="blur"
            blurDataURL="./"
            fill
            quality={100}
            alt={'concept'}
            style={{
              borderRadius: 'inherit',
              objectFit: 'cover',
            }}
          />
        </div>
        <AdditionalInfo width="full-w" variant="success">
          {infoByStep[step].text}
        </AdditionalInfo>
      </ModalContent.Body>
      <ModalContent.Footer className={styles['footer']}>
        <TagInfo variant="status" className={styles['tag']}>
          {`${step} of 5`}
        </TagInfo>
        <div className={styles['buttons-container']}>
          {step > 1 && (
            <Button
              variant="secondary"
              iconLeft={
                <Illustration spriteName={'icons'} name={'arrow-left'} />
              }
              width="content"
              onClick={() => withdrawalStore.prevGuideStep()}
              className={styles['prev-btn']}
            />
          )}
          {step < Object.keys(infoByStep).length ? (
            <Button
              iconRight={
                <Illustration spriteName={'icons'} name={'alt-arrow-right'} />
              }
              width="content"
              className={styles['next-btn']}
              text="Next"
              onClick={() => withdrawalStore.nextGuideStep()}
            />
          ) : (
            <Button
              width="content"
              className={styles['next-btn']}
              text="Understood"
              onClick={onClose}
            />
          )}
        </div>
      </ModalContent.Footer>
    </ModalContent>
  );
};
